// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rn-0";